import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './PositionForm.module.scss'
import { Field as FormikField, Form as FormikForm, useFormikContext } from 'formik'
import { Button, Field } from '@/ui'
import { formFieldNames } from './formFieldNames'
import { WrappedCheckbox } from '@features/contracts/registrationEmployerContract/form/fields'
import { formatDecimalInput } from '@/utils'
import RadioStaff from '@/components/RadioStaff/RadioStaff'
import { useSelector } from 'react-redux'
import cl from 'classnames'

export const WorkPlaceForm = ({ onClose, positions, positionsByKnz, laborMobilityCenterCategory, structureDeptTypeCode, actions }) => {
	const { t } = useTranslation()
	const { values } = useFormikContext()
	const { activeCompany } = useSelector((state) => ({
		activeCompany: state.company.company
	}))

	return (
		<FormikForm className={styles.form}>
			<section>
				<div className={styles.item}>
					<div className={`${styles.checkboxFields} ${styles.fields_verticalCenter}`}>
						<div className={styles.label}>
							<FormikField name={formFieldNames.freelance}>
								{({ field }) => <WrappedCheckbox {...field} label={t('staff_modal.freelancer_position')} />}
							</FormikField>
						</div>
					</div>
					<FormikField name={formFieldNames.isDicPosition}>
						{({ field }) => (
							<div className={'flex'}>
								<RadioStaff label={t('workplace.manual_input')} value="2" id="2" checked={field.value === '2'} />
								<RadioStaff label={t('workplace.directory')} value="3" id="3" checked={field.value === '3'} />
							</div>
						)}
					</FormikField>
					{values[formFieldNames.isDicPosition] === '2' ? (
						<div className={styles.twoFields}>
							<FormikField name={formFieldNames.nameKz}>
								{({ field, meta: { touched, error } }) => (
									<Field
										{...field}
										type="text"
										name={t('staff_modal.position_kz')}
										label={t('staff_modal.position_kz')}
										placeholder={t('staff_modal.position_placeholder')}
										isRequired
										error={touched && error}
										disabled={true}
									/>
								)}
							</FormikField>
							<FormikField name={formFieldNames.nameRu}>
								{({ field, meta: { touched, error } }) => (
									<Field
										{...field}
										type="text"
										label={t('staff_modal.position_ru')}
										placeholder={t('staff_modal.position_placeholder')}
										isRequired
										error={touched && error}
										disabled={true}
									/>
								)}
							</FormikField>
						</div>
					) : (
						<FormikField name="position">
							{({ field, meta: { touched, error } }) => (
								<Field
									{...field}
									fieldType="selectSearch"
									label={t('contract.info.position')}
									placeholder={t('position_placeholder')}
									options={positions}
									error={touched && error}
									disabled={true}
								/>
							)}
						</FormikField>
					)}
					<FormikField name={formFieldNames.positionCode}>
						{({ field, meta: { touched, error } }) => (
							<Field
								{...field}
								fieldType="selectSearch"
								label={t('contract.info.nkz_position')}
								placeholder={t('choose_from_directory')}
								options={positionsByKnz}
								error={touched && error}
								disabled={true}
							/>
						)}
					</FormikField>
					<FormikField name={formFieldNames.staffCategory}>
						{({ field, meta: { touched, error } }) => (
							<Field
								{...field}
								fieldType="select"
								label={t('staff_modal.position_category')}
								placeholder={t('choose_from_directory')}
								options={laborMobilityCenterCategory}
								error={touched && error}
								disabled={true}
							/>
						)}
					</FormikField>
					<div className={`${styles.fields} ${styles.threeFields}`}>
						<div>
							<FormikField name={formFieldNames.staffUnitsCount}>
								{({ field, meta: { touched, error } }) => (
									<Field
										{...field}
										type="number"
										hideNumberArrows
										placeholder={actions.edit ? t('staff.staff_units_placeholder') : t('staff.staff_units_placeholder')}
										error={touched && error}
										label={actions.edit ? t('workplace.staff_unit') : t('workplace.tariff_rate')}
										isRequired
										onChange={(value) => {
											const regex = /^\d+(\.\d{0,4})?$/;
											if (value === '' || regex.test(value)) {
												field.onChange(value)
											}
										}}
									/>
								)}
							</FormikField>
						</div>
						<FormikField name={formFieldNames.grossSalary}>
							{({ field, meta: { touched, error } }) => (
								<Field
									{...field}
									type="text"
									hideNumberArrows
									fieldType={'inputNumber'}
									isRequired
									label={t('staffing_table.salary')}
									placeholder={t('staff_modal.salary_placeholder')}
									error={touched && error}
									value={field.value}
									onChange={(event) => {
										const next = formatDecimalInput(event.target.value, 2)
										field.onChange(next)
									}}
									autoComplete="off"
								/>
							)}
						</FormikField>
						<FormikField name={formFieldNames.salarySupplement}>
							{({ field, meta: { touched, error } }) => (
								<Field
									{...field}
									type="text"
									fieldType={'inputNumber'}
									hideNumberArrows
									label={t('staffing_table.supplement_surcharge')}
									placeholder={t('staff_modal.supplement_surcharge_placeholder')}
									error={touched && error}
									value={field.value}
									onChange={(event) => {
										const next = formatDecimalInput(event.target.value, 2)
										field.onChange(next)
									}}
									autoComplete="off"
								/>
							)}
						</FormikField>
					</div>
				</div>

				{actions.edit ? null : (
					<div className={cl('mt-4')}>
						<p>
							{t('workplace.count_tariff_rate')}
							<i>{' - ' + t('staff.staff_units_count_hint_1')}</i>
						</p>
					</div>
				)}
			</section>
			<div className={styles.actions}>
				<Button type="bare" onClick={onClose}>
					{t('cancel')}
				</Button>
				<Button textColor="green" borderColor="green" transparent border type="submit">
					{t('save')}
				</Button>
			</div>
		</FormikForm>
	)
}
